<template>
  <div>
    <v-tabs
      grow
      ref="tabs"
      bg-color="secondary"
      v-model="tab"
      slider-color="primary"
      align-tabs="center"
      id="insights-tabs">
      <v-tab value="all" :to="{ name: 'insights' }" v-if="!novaCore.isInternalUser($me)">
        {{ $t('insights.tabLabels.allInsights') }}
      </v-tab>
      <v-tab
        value="carrier"
        :to="{ name: 'insights.carrier' }"
        v-if="!novaCore.isInternalUser($me)">
        {{ $t('insights.tabLabels.carrierInsights') }}
      </v-tab>
      <v-tab
        value="warehouse"
        :to="{ name: 'insights.warehouse' }"
        v-if="!novaCore.isInternalUser($me)">
        {{ $t('insights.tabLabels.warehouseInsights') }}
      </v-tab>
      <v-tab
        value="reporting"
        :to="{ name: 'insights.reporting' }"
        v-if="!novaCore.isInternalUser($me)">
        {{ $t('insights.tabLabels.reporting') }}
      </v-tab>
      <v-tab
        value="internal"
        v-if="novaCore.isInternalRole($me.role)"
        :to="{ name: 'insights.internal' }">
        {{ $t('insights.tabLabels.internalInsights') }}
      </v-tab>
    </v-tabs>

    <v-tabs-window v-model="tab">
      <v-tabs-window-item value="all">
        <v-card v-if="tab === 'all'">
          <feature-flag name="enable-power-bi-all-insights">
            <template #not-ready>
              <div class="d-flex justify-center align-center">
                <v-progress-circular color="primary" indeterminate size="42" />
                <p class="text-body-1 ml-4 py-10 font-weight-bold">
                  {{ $t('insights.messages.loadingInsightsData') }}...
                </p>
              </div>
            </template>
            <template #enabled>
              <power-bi-insights :title="insightsTitle" :url="insightsUrl" />
            </template>
            <template #disabled>
              <chart-grid />
            </template>
          </feature-flag>
        </v-card>
      </v-tabs-window-item>
      <v-tabs-window-item value="carrier" v-if="!novaCore.isInternalUser($me)">
        <power-bi-insights :title="carrierTitle" :url="carrierUrl"></power-bi-insights>
      </v-tabs-window-item>
      <v-tabs-window-item value="warehouse" v-if="!novaCore.isInternalUser($me)">
        <power-bi-insights
          :title="warehouseTitle"
          :url="warehouseUrl"
          v-if="tab === 'warehouse'"></power-bi-insights>
      </v-tabs-window-item>
      <v-tabs-window-item value="reporting" v-if="!novaCore.isInternalUser($me)">
        <appointment-reporting-table v-if="tab === 'reporting'"></appointment-reporting-table>
      </v-tabs-window-item>
    </v-tabs-window>
  </div>
</template>

<script>
import { FeatureFlag } from '@loadsmart/vue-feature-flags';

export default {
  components: { FeatureFlag },
  data() {
    return {
      insightsTitle: 'All Insights',
      insightsUrl: '/reporting/all-insights',
      carrierTitle: 'Carrier Performance',
      carrierUrl: '/reporting/carrier-insights',
      warehouseTitle: 'Warehouse Performance',
      warehouseUrl: '/reporting/warehouse-insights',
      tab: null,
      tabsName: {
        '/insights/reporting': 'Reporting',
        '/insights': 'All Insights',
        '/insights/carrier': 'Carrier Insights',
        '/insights/warehouse': 'Warehouse Insights'
      }
    };
  },
  mounted() {},
  watch: {
    tab(value, oldValue) {
      // this will avoid trigerring "all insights" event every time it loads the page
      if (oldValue !== null) {
        this.mixpanel.track(this.mixpanel.events.MODULE.REPORTING.VIEW_PAGE, {
          'Org Name': this.$org.name,
          'Org ID': this.$org.id,
          'Insights Tab': this.tabsName[value]
        });
      }
    }
  }
};
</script>

<style lang="scss">
#insights-tabs {
  .v-tabs-slider-wrapper,
  .v-tabs-slider-wrapper {
    height: 4px !important;
  }
}
</style>
